<div class="py-2 pt-4 px-4">
  <h3 class="font-light border-b border-gray-300 mb-1"> Adresses <span
    class="float-right text-base">{{intervention.start_time | date :'shortTime'}}
    - {{intervention.stop_time | date :'shortTime'}} ({{intervention.start_time | date :'shortDate'}})</span></h3>
  <div class="grid p-1 grid-cols-4 gap-3 history-metrics">
    <div title="Adresse 1" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Adresse 1</div>
      <span class="metric-value">{{intervention.endpoints.first_poi_name}}</span>
    </div>
    <div title="Adresse 2" *ngIf="intervention.endpoints.second_poi_name" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Adresse 2</div>
      <span class="metric-value">{{intervention.endpoints.second_poi_name}}</span>
    </div>
    <div title="Distance" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Distance</div>
      <span class="metric-value">{{intervention.metrics.length_in_km | number}} <span
        class="metric-unit">km</span></span>
    </div>
    <div title="Allers-retours" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Aller-retours</div>
      <span class="metric-value">{{intervention.endpoints.roundTrips | number}} <span
        class="metric-unit">fois</span></span>
    </div>
  </div>
</div>

<div class="py-2 px-4 pt-0">
  <h3 class="font-light border-b border-gray-300 mb-1"> Consomation Carburant </h3>
  <div class="grid p-1 grid-cols-4 gap-3 history-metrics">
    <div title="Totale" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Totale</div>
      <span class="metric-value">{{intervention.metrics.fuel_total_consumption | number}} <span
        class="metric-unit">L</span></span>
    </div>
    <div title="Par Heure" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Par Heure</div>
      <span class="metric-value">{{intervention.metrics.fuel_hourly_consumption_rate_avg | number}} <span
        class="metric-unit">L/h</span></span>
    </div>
    <div title="Heures Moteurs" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Heures Moteurs</div>
      <span class="metric-value">{{intervention.metrics.engine_working_hours | number}} <span
        class="metric-unit">h</span></span>
    </div>
    <div title="Temperature" class="shadow-sm hover:shadow cursor-pointer">
      <div class="metric-text">Temperature</div>
      <span class="metric-value">{{intervention.metrics.fuel_temperature_avg | number}} <span
        class="metric-unit">°C</span></span>
    </div>
  </div>
</div>

<div>
  <div class="grid grid-cols-2 gap-3">
    <div>
      <div class="py-2 px-4 pt-0">
        <h3 class="font-light border-b border-gray-300 mt-4 mb-2">Machines & Outils</h3>
        <div class="grid p-1 grid-cols-2 gap-3 history-metrics">
          <div title="Véhicule" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Véhicule</div>
            <span class="metric-value">{{intervention.vehicle.name}}</span>
          </div>
          <div title="Outil" *ngIf="intervention.tag_details.taggable" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Outil</div>
            <span class="metric-value">{{intervention.tag_details.taggable.taggable_name}}</span>
          </div>
        </div>
      </div>

      <div class="py-2 px-4 pt-0">
        <h3 class="font-light border-b border-gray-300 mb-2">Vitesse</h3>
        <div class="grid p-1 grid-cols-2 gap-3 history-metrics">
          <div title="Moyenne" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Moyenne</div>
            <span class="metric-value">{{intervention.metrics.speed_avg | number}} <span
              class="metric-unit">Km/h</span></span>
          </div>
          <div title="Maximale" class="shadow-sm hover:shadow cursor-pointer">
            <div class="metric-text">Maximale</div>
            <span class="metric-value">{{intervention.metrics.speed_max | number}} <span
              class="metric-unit">Km/h</span></span>
          </div>
        </div>
      </div>
    </div>
    <div class="p-4">
      <app-transport-interventions-metrics-charts
        [intervention]="intervention"
        [poiList]="poiList"
        [poiListGroupReport]="poiListGroupReport"></app-transport-interventions-metrics-charts>
    </div>
  </div>
</div>

